<template>
    <div>
        <div class="content-box first">
            <RsStep class="full m-b-8" :active="0" :steps="['发起分账', '确认并签署合同', '完成分账']"></RsStep>
            <div class="flex" style="align-items: center; margin-bottom: 30px">
                <label style="width: 100px">可分账歌曲</label>
                <el-select
                    v-model="currentSong.trackId"
                    filterable
                    remote
                    :remote-method="remoteMethod"
                    :disabled="!!currentSong.trackId"
                    :loading="songsLoading"
                    @change="changeSong"
                    placeholder="输入关键字查询歌曲"
                >
                    <el-option v-for="(item, index) in songsOptions" :key="index" :label="item.trackName" :value="item.trackId"></el-option>
                </el-select>
            </div>
            <div v-if="currentSong.trackId">
                <p class="sr-tips">
                    1. 请线下先确认好对方在秀动发行的注册手机号和分成比例，以免存在无法确认分成的情况
                    <br />
                    2. 请填写
                    <span class="danger">真实名字</span>
                    ，如果手机号和真实名称无法对应，无法接受分成（如果对方是企业入驻，请输入企业营业执照上的企业名称）
                    <br />
                    3. 确认分成后，系统会检测用户的注册和认证情况，请根据系统提示完成
                </p>
                <ProportionInput style="margin-top: 40px" :info="myself" myself disabled />
                <ProportionInput
                    v-for="(row, index) in list"
                    :key="index"
                    :info="row"
                    :disabled="!row.isEdit"
                    @update="onUpdate($event, index)"
                    style="margin-top: 30px"
                />
            </div>
            <div style="text-align: center; margin-top: 30px">
                <el-button v-loading="submitLoading" @click="submit" type="primary">验证并确认分账</el-button>
            </div>
        </div>
        <SongsRuleConfirm ref="songsRuleConfirm" @next="onNext"></SongsRuleConfirm>
    </div>
</template>

<script>
import ProportionInput from '../components/ProportionInput';
import SongsRuleConfirm from '../components/SongsRuleConfirm';
import {querySongs, getInfo, addSongsRule} from '@/api/distribute';

export default {
    components: {
        ProportionInput,
        SongsRuleConfirm,
    },
    data() {
        return {
            currentSong: {trackId: ''},
            songsOptions: [],
            songsLoading: false,
            list: [],
            submitLoading: false,
            type: 'add', // add or edit
            captcha: null,
            status: 0,
            currentRule: null,
        };
    },
    computed: {
        myself() {
            const {name, telephone} = this.$store.state.userInfo;
            const addList = this.list.filter((row) => row.telephone);
            const minusRatio = addList.reduce((prev, curr) => prev - curr.ratio, 100);
            return {name, telephone, ratio: minusRatio};
        },
    },
    mounted() {
        const {query} = this.$route;
        const {trackId, albumId, trackName} = query;
        if (trackId) {
            this.type = 'edit';
            this.songsOptions = [{trackId, albumId, trackName}];
            this.currentSong = {trackId, albumId, trackName};
            this.getDetail(trackId, albumId);
        }
        this.loadCaptcha();
    },
    methods: {
        setStatus(list) {
            const statusSet = new Set(list.map((obj) => obj.verifyStatus));
            if (statusSet.has(0)) return 0;
            if (statusSet.has(1)) return 1;
            if (statusSet.has(2)) return 2;
            return 3;
        },
        async getDetail(trackId, albumId) {
            const response = await getInfo(trackId, albumId);
            const {msg, state, result} = response.data;
            if (!state) return this.$message.error(msg || '');
            const {ruleList} = result;
            this.status = this.setStatus(ruleList);
            let newList = ruleList.filter((item) => item.toCpRealName !== '自己');
            newList = newList.map((row) => ({
                name: row.toCpRealName,
                telephone: row.toCpPhoneNum,
                ratio: Number((row.toCpRate * 100).toFixed(2)),
                isEdit: row.verifyStatus === 0,
                ruleId: row.ruleId,
            }));
            if (this.status === 3) newList.push({name: '', telephone: '', ratio: '', isEdit: true});
            this.list = newList;
        },
        onUpdate(row, index) {
            this.$set(this.list, index, row);
        },
        async remoteMethod(query) {
            if (query) {
                this.songsLoading = true;
                const response = await querySongs(query);
                const {msg, state, result} = response.data;
                if (!state) return this.$message.error(msg || '');
                this.songsOptions = result.result;
                this.songsLoading = false;
            } else {
                this.songsOptions = [];
            }
        },
        async changeSong(id) {
            const row = this.songsOptions.find((item) => item.trackId === id);
            if (!row) return;
            this.loading = true;
            this.currentSong = row;
            await this.getDetail(row.trackId, row.albumId);
            this.loading = false;
        },
        loadCaptcha() {
            this.$utils.loadScript({id: 'tcaptcha', url: 'https://turing.captcha.qcloud.com/TCaptcha.js'}, () => {
                // eslint-disable-next-line no-undef
                this.captcha = new TencentCaptcha(this.$config.CaptchaAppId, (res) => {
                    if (res.ret === 0) this.onConfirm();
                });
            });
        },
        onNext(type) {
            if (type) {
                this.$message.success('添加分账人信息成功');
                this.$contractRouter(`/manage/contract/distribute/fdd/signContract?ruleId=${this.currentRule.ruleId}`);
            } else {
                window.location.replace(
                    `/manage/distribute/detail/1?trackId=${this.currentSong.trackId}&albumId=${this.currentSong.albumId}&trackName=${this.currentSong.trackName}`
                );
            }
        },
        async onConfirm() {
            this.submitLoading = true;
            const newRule = this.list.find((row) => row.isEdit);
            const formData = {
                ...this.currentSong,
                toCpRate: Number((newRule.ratio / 100).toFixed(2)),
                toCpRealName: newRule.name,
                toCpPhoneNum: newRule.telephone,
            };
            if (newRule.ruleId) formData.ruleId = newRule.ruleId;
            const response = await addSongsRule(formData);
            const {msg, state, result} = response.data;
            this.submitLoading = false;
            if (!state) return this.$message.error(msg || '');
            this.currentRule = result;
            this.$refs.songsRuleConfirm.show(result);
        },
        async submit() {
            const newRule = this.list.find((row) => row.isEdit);
            if (!newRule || !newRule.name || !newRule.telephone || !newRule.ratio) return this.$message.error('请完善分账人信息');
            this.captcha.show();
        },
    },
};
</script>
<style lang="scss" scoped></style>
